import React from 'react';
import styles from './styles.module.css';

interface BananaSpinnerProps {
  width?: number;
  height?: number;
  noSpinner?: boolean;
}

export const BananaSpinner = ({
  width = 24,
  height = 24,
  noSpinner = false,
}: BananaSpinnerProps) => {
  return (
    <img
      style={{width, height}}
      src={'/banana.png'}
      alt='send'
      className={noSpinner ? '' : styles.spinner}
    />
  );
};
